var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "31fbcb64-be05-4425-b6ec-e08f320070d1",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon1",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon1",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/92626370-383e-46ea-94da-c5468a70905a/d1295858d2008135a02c5cb2d36e46917468f646/",
    core: "4.5.0",
    title: "Deco2",
    type: "haiku",
    relpath: "code/deco2/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Deco2-20cb245cfb651e73": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 9.793,
        "sizeAbsolute.y": 9.131,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:Deco2-d86fd6656e8c6872": {
        "sizeAbsolute.y": 8,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 8,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeMode.y": 1,
        "translation.x": 4.8965000000000005,
        "translation.y": 4.5655,
        "style.zIndex": 1,
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "667": { value: 6.284 }
        }
      },
      "haiku:Page-1-746d6e09d76475e1": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Version-Control-Icon-b0fc5f92d45a70a8": {
        fill: "#EF33F8",
        "translation.x": -1,
        "translation.y": -28
      },
      "haiku:Deco2-5ce41be234881a8e": {
        x: 1.92784756,
        y: 29.2277064,
        width: 5.94212411,
        height: 5.94212411,
        rx: 1,
        "translation.x": -14.996046,
        "translation.y": 6.41213,
        "rotation.z": 5.77704
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Deco2-20cb245cfb651e73",
      "haiku-title": "Deco2"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Deco2-d86fd6656e8c6872",
          "haiku-title": "deco2",
          "haiku-source":
            "designs/AnimatorWebsiteIcon1.sketch.contents/slices/deco2.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-746d6e09d76475e1", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Version-Control-Icon-b0fc5f92d45a70a8",
                  id: "VersionControl-icon"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "Deco2-5ce41be234881a8e",
                      id: "deco2"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon1/code/deco2/code.js
// module id = 425
// module chunks = 35783957827783